import { css } from 'styled-components';

/** Native scrolling with a quiet rounded thumb; retains dragging and keyboard scrolling. */
export const quietScrollbar = css`
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.color.textMuted} transparent;
  @supports selector(::-webkit-scrollbar) {
    /* Let the pseudo-elements style Chromium instead of the standard override. */
    scrollbar-width: auto;
    scrollbar-color: auto;
    &::-webkit-scrollbar { width: 10px; height: 10px; }
    &::-webkit-scrollbar-track { background: transparent; margin-block: 12px; }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.hairSoft};
      background-clip: padding-box;
      border: 3px solid transparent;
      border-radius: 999px;
      min-height: 36px;
    }
    &:hover::-webkit-scrollbar-thumb,
    &:focus-within::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.textMuted};
    }
    &::-webkit-scrollbar-thumb:hover { background-color: ${({ theme }) => theme.color.textPrimary}; }
    &::-webkit-scrollbar-button { display: none; width: 0; height: 0; }
    &::-webkit-scrollbar-corner { background: transparent; }
  }
  @media (forced-colors: active) {
    scrollbar-color: auto;
    &::-webkit-scrollbar-thumb { background-color: ButtonText; }
  }
`;
